import { ResponsiveImage } from '@/components/elements/ResponsiveImage';
import { IUploadFileEntity } from '@/graphql/__generated__/global/types';
import { getAspectRatio } from '@/lib/getAspectRatio';
import { getImageUrl } from '@/lib/getImageUrl';

type CarouselSlideProps = {
    image: IUploadFileEntity;
    onClick: (file?: IUploadFileEntity) => void;
};

const CarouselSlide = ({ image, onClick }: CarouselSlideProps) => {
    const { attributes } = image;
    const { alternativeText } = attributes || {};

    return (
        <div className="embla__slide">
            <ResponsiveImage
                alt={alternativeText || ''}
                aspectRatio={getAspectRatio(attributes)}
                src={getImageUrl(image)}
                onClick={() => onClick(image)}
                className="rounded-2xl h-auto"
                sizes={`(max-width: 639px) 70vw, (max-width: 1951px) 50vw, 904px`}
            />
        </div>
    );
};

export default CarouselSlide;
